import { Placeholder } from "rsuite";

const { Paragraph, Graph, Grid } = Placeholder;

export const ProfileCardPlaceholder = () => (
  <div className="d-flex align-items-center">
    <div>
      <Graph
        width={120}
        height={120}
        className="img-fluid rounded-circle p-3"
        active
      />
    </div>
    <div className="ms-5 d-block">
      <Paragraph rowHeight={20} active />
      <p className="text-white">Placeholder Placeholder</p>
    </div>
  </div>
);

export const TableCardPlaceholder = (props: { rows: number }) => (
  <Grid
    rows={props.rows || 5}
    rowHeight={20}
    rowMargin={25}
    columns={2}
    className="p-4"
    active
  />
);
